$('[data-afp-pwd-toggle]')
    .each((index, element) => {
            const button = $(element);
            const inputId = button.attr('data-afp-pwd-toggle');
            const input = $('#' + inputId);
            const textTargetId = button.attr('data-afp-pwd-text-target');
            const textTarget = !!textTargetId ? $('#' + textTargetId) : button;

            const visibleClass = button.attr('data-afp-pwd-visible-class');
            const visibleText = button.attr('data-afp-pwd-visible-text') || 'visibility_off';
            const visibleAriaText = button.attr('data-afp-pwd-visible-aria-label') || 'Hide password';

            const invisibleClass = button.attr('data-afp-pwd-invisible-class');
            const invisibleText = button.attr('data-afp-pwd-invisible-text') || 'visibility';
            const invisibleAriaText = button.attr('data-afp-pwd-invisible-aria-label') || 'Show password';

            button.attr('aria-controls', inputId);
            if (input.attr('type') === 'password') {
                textTarget.text(invisibleText);
                button.attr('aria-label', invisibleAriaText);
                if (invisibleClass) {
                    button.addClass(invisibleClass);
                }
                if (visibleClass) {
                    button.removeClass(visibleClass)
                }
            } else {
                textTarget.text(visibleText);
                button.attr('aria-label', visibleAriaText);
                if (visibleClass) {
                    button.addClass(visibleClass)
                }
                if (invisibleClass) {
                    button.removeClass(invisibleClass);
                }
            }

            button.click(function () {
                if (input.attr('type') === 'password') {
                    input.attr('type', 'text');
                    textTarget.text(visibleText);
                    button.attr('aria-label', visibleAriaText);
                    if (visibleClass) {
                        button.addClass(visibleClass)
                    }
                    if (invisibleClass) {
                        button.removeClass(invisibleClass);
                    }
                } else {
                    input.attr('type', 'password');
                    textTarget.text(invisibleText);
                    button.attr('aria-label', invisibleAriaText);
                    if (invisibleClass) {
                        button.addClass(invisibleClass);
                    }
                    if (visibleClass) {
                        button.removeClass(visibleClass)
                    }
                }
            });
        }
    );